import { createTheme } from '@uhg-abyss/web/tools/theme';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { RouterProvider } from '@uhg-abyss/web/ui/RouterProvider';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { ToastProvider } from '@uhg-abyss/web/ui/Toast';

import { ProviderDirectory } from '../../common/ProviderDirectory/ProviderDirectory';
import ProviderDirectoryFooter from '../../common/ProviderDirectory/ProviderDirectoryFooter';
import ProviderDirectoryHeader from '../../common/ProviderDirectory/ProviderDirectoryHeader';
import { ErrorBoundary } from '../../errors/ErrorBoundary';
import { Configuration } from './context/Configuration/Configuration';
import { createRouter } from './createRouter';

export const App = () => (
  <ErrorBoundary>
    <OverlayProvider>
      <ToastProvider containerWidth="26rem" />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <ProviderDirectoryHeader />
        <ProviderDirectory />
        <ProviderDirectoryFooter />
      </div>
    </OverlayProvider>
  </ErrorBoundary>
);

const router = createRouter(App);

export const DocumentDirectory = () => {
  const theme = createTheme('uhc', {});

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <Configuration>
          <RouterProvider router={router}></RouterProvider>
        </Configuration>
      </ThemeProvider>
    </ErrorBoundary>
  );
};
